export default "__VITE_PUBLIC_ASSET__3d35cb33__"